import { jsxs as a, Fragment as l, jsx as r } from "react/jsx-runtime";
import * as s from "react";
import { memo as h, useState as m } from "react";
import { Drawer as v } from "antd";
import { I as d, _ as f } from "../../../../AntdIcon-DyhIFdCf.js";
import { R as p } from "../../../../CloseOutlined-CTXw7BrO.js";
var u = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74z" } }] }, name: "sliders", theme: "outlined" }, x = function(t, e) {
  return /* @__PURE__ */ s.createElement(d, f({}, t, {
    ref: e,
    icon: u
  }));
}, n = /* @__PURE__ */ s.forwardRef(x);
process.env.NODE_ENV !== "production" && (n.displayName = "SlidersOutlined");
const V = ({ children: c }) => {
  const [t, e] = m(!1), i = () => {
    e(!0);
  }, o = () => {
    e(!1);
  };
  return /* @__PURE__ */ a(l, { children: [
    /* @__PURE__ */ a(
      "span",
      {
        className: "at-text-sm at-mr-4 at-cursor-pointer",
        onClick: i,
        children: [
          /* @__PURE__ */ r(n, { className: "at-mr-2" }),
          " 更多篩選條件"
        ]
      }
    ),
    /* @__PURE__ */ r(
      v,
      {
        title: "商品篩選條件",
        onClose: o,
        open: t,
        zIndex: 999999,
        width: "90%",
        placement: "left",
        extra: /* @__PURE__ */ r(p, { onClick: o }),
        forceRender: !0,
        closeIcon: null,
        children: c
      }
    )
  ] });
}, N = h(V);
export {
  N as default
};
